import React, { useEffect, useState } from "react";
import { cn } from "../utils";

/**
 * Keep tab panels mounted once visited; hide inactive panels instantly via CSS
 * so the previous tab's content doesn't flash during URL-driven navigation.
 */
export function TabKeepAlive({ tabId, activeTab, className, children }) {
  const isActive = activeTab === tabId;
  const [visited, setVisited] = useState(isActive);

  useEffect(() => {
    if (isActive) setVisited(true);
  }, [isActive]);

  const mounted = visited || isActive;
  if (!mounted) return null;

  return (
    <div
      className={cn(
        "flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden",
        !isActive && "hidden",
        className
      )}
      aria-hidden={!isActive}
      hidden={!isActive}
    >
      {children}
    </div>
  );
}
